import {Component, ViewContainerRef} from '@angular/core';
import {FBAPIInitService} from './manager/shared/service/fbapi';
import {googleAnalytics} from '../assets/script';
import {NavigationStart , Router} from '@angular/router';



@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  public title = 'app works!';

  public constructor(private viewContainerRef: ViewContainerRef,
                     private fb: FBAPIInitService,
                     private  router: Router) {
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe (event => {
       const url =  event['url'];
       if (url !==  null  &&  url !== undefined  &&  url !==  ''  && url.indexOf('null') <  0) {
         googleAnalytics(url);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts